module.exports = __webpack_public_path__ + "img/AU.720fe31c.png";